import { render, staticRenderFns } from "./codeUI.vue?vue&type=template&id=209de45a&scoped=true"
import script from "./codeUI.vue?vue&type=script&lang=js"
export * from "./codeUI.vue?vue&type=script&lang=js"
import style0 from "./codeUI.vue?vue&type=style&index=0&id=209de45a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209de45a",
  null
  
)

export default component.exports